import React, {Component} from 'react';
import {connect} from 'react-redux';
import PerkAction from '../../actions/PerkAction';
import Preloader from '../Preloader';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

class Perks extends Component {

  constructor(props) {
    super(props)
    let defaultTab = 0;
    if (props.location.query.back === 'friends_rewards') {
      defaultTab = 1;
    }
    this.state = {
      sorting: {
        field: '',
        direction: 'asc'
      },
      defaultTab: defaultTab,
      limit: 30
    };
  }



  componentDidMount() {
    var filter = [
      {name: 'limit', value: this.state.limit},
      {name: 'offset', value : 0}
    ];
    this.props.loadList(filter);
  }

  sortBy(fieldName) {
    var direction = this.state.sorting.direction === 'asc' ? 'desc' : 'asc';
    this.setState({
      sorting: {
        field: fieldName,
        direction: direction
      }
    });
    var filter = [
      {name: 'limit', value: this.state.limit},
      {name: 'offset', value : 0},
      {name: 'sort_by', value : fieldName},
      {name: 'sort_dir', value :direction}
    ];
    this.props.loadList(filter);
  }

  handlePageClick(data) {
    var filter = [
      {name: 'limit', value: this.state.limit},
      {name: 'offset', value : data.selected * this.state.limit}
    ];
    if (this.state.sorting.field !== '') {
      filter.push({name: 'sort_by', value : this.state.sorting.field});
      filter.push({name: 'sort_dir', value : this.state.sorting.direction});
    }
    this.props.loadList(filter);
  }

  render() {
    var fieldName = this.state.sorting.field;
    var direction = this.state.sorting.direction === 'asc' ? 'fa fa-sort-asc' : 'fa fa-sort-desc';
    if (this.props.perks.length === 0 && this.props.isBusy) {
      return <Preloader />;
    } else {
      return <div>
        <div className="row" style={{margin: '0px 15px'}}>
          <div className="col-md-12">
            <Tabs defaultIndex={this.state.defaultTab}>
              <TabList>
                <Tab>Customer Rewards</Tab>
                <Tab>Friends’ rewards</Tab>
              </TabList>
              <TabPanel>
                <div className="panel-control">
                  <a href="/#/perks/add" className="btn btn-action">New Perk for Customer Rewards</a>
                </div>
                <div className="panel panel-default">
                  <div className="panel-heading">
                    <h3 className="panel-title">Visible</h3>
                  </div>
                  <div className="panel-body">
                    <table className="table table-condensed table-responsive table-view">
                      <thead>
                      <tr>
                        <th className="bold">
                          <a onClick={() => this.sortBy('title')}>
                            <i className={fieldName === 'title' ? direction : 'fa fa-sort'} aria-hidden="true"></i>
                            &nbsp;Title
                          </a>
                        </th>
                        <th className="bold">
                          <a onClick={() => this.sortBy('required_referrals')}>
                            <i className={fieldName === 'required_referrals' ? direction : 'fa fa-sort'} aria-hidden="true"></i>
                            &nbsp;Required Referrals
                          </a>
                        </th>
                        <th className="bold"></th>
                      </tr>
                      </thead>
                      <tbody>
                      {this.props.perks.filter((item) => !item.referral_bonus && item.enabled).map((item, key) => {
                        return (
                          <tr key={key} className="form-group">
                            <td>
                              {item.title}
                            </td>
                            <td>
                              {item.required_referrals}
                            </td>
                            <td>
                              <a href={`/#/perks/${item.id}/view`} >View</a>
                              <a href={`/#/perks/${item.id}/edit`} className="ml10">Edit</a>
                            </td>
                          </tr>
                        )
                      })}
                      {this.props.perks.filter((item) => !item.referral_bonus && item.enabled).length === 0 && !this.props.isBusy ? <tr>
                        <td className="text-center" colSpan={7}>Nothing to show</td>
                      </tr> : null}
                      <tr>
                        <td className="text-center absolute" colSpan={6}>
                          {this.props.isBusy ? <Preloader /> : null}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                </div>
                </div>
                <div className="panel panel-default">
                  <div className="panel-heading">
                    <h3 className="panel-title">Hidden</h3>
                  </div>
                  <div className="panel-body">
                    <table className="table table-condensed table-responsive table-view">
                      <thead>
                      <tr>
                        <th className="bold">
                          <a onClick={() => this.sortBy('title')}>
                            <i className={fieldName === 'title' ? direction : 'fa fa-sort'} aria-hidden="true"></i>
                            &nbsp;Title
                          </a>
                        </th>
                        <th className="bold">
                          <a onClick={() => this.sortBy('required_referrals')}>
                            <i className={fieldName === 'required_referrals' ? direction : 'fa fa-sort'} aria-hidden="true"></i>
                            &nbsp;Required Referrals
                          </a>
                        </th>
                        <th className="bold"></th>
                      </tr>
                      </thead>
                      <tbody>
                      {this.props.perks.filter((item) => !item.referral_bonus && !item.enabled).map((item, key) => {
                        return (
                          <tr key={key} className="form-group">
                            <td>
                              {item.title}
                            </td>
                            <td>
                              {item.required_referrals}
                            </td>
                            <td>
                              <a href={`/#/perks/${item.id}/view`} >View</a>
                              <a href={`/#/perks/${item.id}/edit`} className="ml10">Edit</a>
                            </td>
                          </tr>
                        )
                      })}
                      {this.props.perks.filter((item) => !item.referral_bonus && !item.enabled).length === 0 && !this.props.isBusy ? <tr>
                        <td className="text-center" colSpan={7}>Nothing to show</td>
                      </tr> : null}
                      <tr>
                        <td className="text-center absolute" colSpan={6}>
                          {this.props.isBusy ? <Preloader /> : null}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="panel-control">
                  <a href="/#/perks/add?mode=friends_rewards" className="btn btn-action">New Perk for Friends’ rewards</a>
                </div>
                <div className="panel panel-default">
                  <div className="panel-heading">
                    <h3 className="panel-title">Rewards</h3>
                  </div>
                  <div className="panel-body">
                  <table className="table table-condensed table-responsive table-view">
                    <thead>
                    <tr>
                      <th className="bold">
                        <a onClick={() => this.sortBy('title')}>
                          <i className={fieldName === 'title' ? direction : 'fa fa-sort'} aria-hidden="true"></i>
                          &nbsp;Title
                        </a>
                      </th>
                      <th className="bold">
                        <a onClick={() => this.sortBy('required_referrals')}>
                          <i className={fieldName === 'required_referrals' ? direction : 'fa fa-sort'} aria-hidden="true"></i>
                          &nbsp;Required Referrals
                        </a>
                      </th>
                      <th className="bold"></th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.props.perks.filter((item) => item.referral_bonus && item.enabled).map((item, key) => {
                      return (
                        <tr key={key} className="form-group">
                          <td>
                            {item.title}
                          </td>
                          <td>
                            {item.required_referrals}
                          </td>
                          <td>
                            <a href={`/#/perks/${item.id}/view`} >View</a>
                            <a href={`/#/perks/${item.id}/edit?mode=friends_rewards`} className="ml10">Edit</a>
                          </td>
                        </tr>
                      )
                    })}
                    {this.props.perks.filter((item) => item.referral_bonus).length === 0 && !this.props.isBusy ? <tr>
                      <td className="text-center" colSpan={7}>Nothing to show</td>
                    </tr> : null}
                    <tr>
                      <td className="text-center absolute" colSpan={6}>
                        {this.props.isBusy ? <Preloader /> : null}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    }
  }
}

export default connect(
  state => ({
    perks: state.perks,
    perksCount: state.perksCount,
    isBusy: state.requestStatus
  }),
  dispatch => ({
    loadList: (filter) => {
      dispatch(PerkAction.getList(filter));
    },
    getPerkCount: () => {
      dispatch(PerkAction.getCount());
    }
  })
)(Perks);



/** WEBPACK FOOTER **
 ** ./src/components/Perks/index.js
 **/